import AssessmentLink from "pages/PanelPage/components/selectedAssessment/assessmentInvite/AssessmentLink/AssessmentLink";

export default AssessmentLink;
